import { normalizeNumber } from '@loggi/js/formatters';
import Col from '@loggi/ui/components/col';
import TextInput from '@loggi/ui/components/text-input';
import View from '@loggi/ui/components/view';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { TOKEN_INPUT } from 'shared/analytics/analytics.constants';
import sendGoogleAnalyticsDataEvent from 'shared/analytics/analytics.utils';
import callMutation from 'shared/relay/mutations/call-mutation';
import mutation from 'shared/relay/mutations/mobile-phone-notification-subscription.mutation';
import TOKEN_ERROR_MESSAGE from './token-input.constants';
import styles from './token-input.styles.scss';

const TOKEN_MAX_LENGTH = 6;
const TOKEN = 'token';

class TokenInput extends Component {
  static propTypes = {
    mobileNumber: PropTypes.string.isRequired,
    packageId: PropTypes.number.isRequired,
    callbackToRenderStatusComponent: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this._handleOnChange = this._handleOnChange.bind(this);

    this.state = {
      token: '',
      tokenErrorMessage: '',
      totalSendingAttempts: 0
    };

    this.textInput = React.createRef();
  }

  _sendGoogleAnalyticsEvent = (action, label, value) => {
    sendGoogleAnalyticsDataEvent({ action, label, value });
  };

  _submitToken = ({ token, mobileNumber, packageId }, callbacks) => {
    const formatMobileNumber = normalizeNumber(mobileNumber);
    const variables = {
      input: {
        token,
        mobileNumber: formatMobileNumber,
        packageId
      }
    };
    return callMutation(mutation, variables, callbacks);
  };

  _checkSuccessResponse(response) {
    const {
      packageTrackerNotificationSubscription: { success, errors }
    } = response;

    const { totalSendingAttempts } = this.state;

    this.setState({ totalSendingAttempts: totalSendingAttempts + 1 });

    if (success) {
      const { callbackToRenderStatusComponent, mobileNumber } = this.props;
      this._sendGoogleAnalyticsEvent(TOKEN_INPUT.SUCCESS);
      return callbackToRenderStatusComponent(mobileNumber);
    }

    const { token } = this.state;
    this._sendGoogleAnalyticsEvent(
      TOKEN_INPUT.FAILURE,
      TOKEN_INPUT.FAILURE_LABEL,
      token
    );
    const error = errors[0];
    const tokenErrorMessage =
      error.field === TOKEN ? error.message : TOKEN_ERROR_MESSAGE.INVALID_TOKEN;

    return this.setState({ tokenErrorMessage });
  }

  _mutationCallbacks() {
    return {
      onSuccess: response => this._checkSuccessResponse(response),
      onFailure: () => {
        const { token } = this.state;
        this._sendGoogleAnalyticsEvent(
          TOKEN_INPUT.FAILURE,
          TOKEN_INPUT.FAILURE_LABEL,
          token
        );
        this.setState({
          tokenErrorMessage: TOKEN_ERROR_MESSAGE.INVALID_TOKEN
        });
      }
    };
  }

  _handleOnChange(inputValue) {
    const { mobileNumber, packageId } = this.props;
    const { totalSendingAttempts } = this.state;
    this.setState({ token: inputValue, tokenErrorMessage: '' }, () => {
      if (inputValue.length === TOKEN_MAX_LENGTH) {
        if (
          totalSendingAttempts <= TOKEN_ERROR_MESSAGE.LIMIT_OF_ATTEMPTS_EXCEEDED
        ) {
          const data = {
            token: inputValue,
            mobileNumber,
            packageId
          };
          this._submitToken(data, this._mutationCallbacks());
        }
        this.textInput.current.blur();
      }
    });
  }

  render() {
    const { tokenErrorMessage, token } = this.state;

    const classesWrap = classNames(styles.tokenInputWrapper, {
      [styles.withErrorBorder]: !!tokenErrorMessage
    });

    return (
      <Col
        gutter={{ top: 'normal', bottom: 'normal' }}
        flexDirection="column"
        alignItems="center"
      >
        <Col size={10}>
          <View className={classesWrap}>
            <TextInput
              size="large"
              placeholder="______"
              onChange={this._handleOnChange}
              value={token}
              inputProps={{
                ref: this.textInput,
                maxLength: TOKEN_MAX_LENGTH
              }}
            />
          </View>
        </Col>
        <Col size={12}>
          {tokenErrorMessage && (
            <View className={styles.tokenErrorMessage}>
              {tokenErrorMessage}
            </View>
          )}
        </Col>
      </Col>
    );
  }
}

export default TokenInput;
